import React, { useEffect, useState } from "react";
import ReactStars from "react-rating-stars-component";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import ProductCard from "../components/ProductCard";
import ReactImageZoom from "react-image-zoom";
import Color from "../components/Color";
import { TbGitCompare } from "react-icons/tb";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import { addToWishlist } from "../features/products/productSlilce";
import { useDispatch, useSelector } from "react-redux";
import cart from "../images/cart.svg";
import { Helmet } from "react-helmet-async";

import {
  addRating,
  getAProduct,
  getAllProducts,
} from "../features/products/productSlilce";
import { toast } from "react-toastify";
import { addProdToCart, getUserCart } from "../features/user/userSlice";
import { getTokenFromLocalStorage, symbole } from "../components/commonData";
import ApiResponseModal from "../components/ApiResponseModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SingleProduct = () => {
  const [color, setColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [alreadyAdded, setAlreadyAdded] = useState(false);
  const [showFullDesc, setShowFullDesc] = useState(false);
  const [ratingImages, setRatingImages] = useState([]);
const DESCRIPTION_LIMIT = 250; // you can change this
  const location = useLocation();
  const navigate = useNavigate();
  const getProductId = location.pathname.split("/")[2];
  const dispatch = useDispatch();
  const productState = useSelector((state) => state?.product?.singleproduct);
  const productsState = useSelector((state) => state?.product?.product);
  const cartState = useSelector((state) => state?.auth?.cartProducts);
  const rat = productState?.totalrating;
  const wishlistState = useSelector((state) => state?.auth?.wishlist?.wishlist);
  const [imgUrl, setImgUrl] = useState(
    productState?.images[0]?.url ||
      "https://commercial.bunn.com/img/image-not-available.png"
  );
  const [apiModal, setApiModal] = useState({
  show: false,
  type: "success",
  title: "",
  message: "",
});
          const config2 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
      }`,
      Accept: "application/json",
    },
  };
  useEffect(() => {
    dispatch(getAProduct(getProductId));
    dispatch(getUserCart(config2));
    dispatch(getAllProducts());
  }, []);

  useEffect(() => {
    for (let index = 0; index < cartState?.length; index++) {
      if (getProductId === cartState[index]?.productId?._id) {
        setAlreadyAdded(true);
      }
    }
  });

  useEffect(() => {
    if (productState?.images[0]?.url) {
      setImgUrl(productState?.images[0]?.url);
    }
  }, [productState?.images[0]?.url]);

  // Check if product has sizes available
  const hasSizes = productState?.size && productState?.size.length > 0;

  const uploadCart = () => {
    if (!getTokenFromLocalStorage) {
       setApiModal({
          show: true,
          type: "info",
          title: "Login Required",
          message: "Please login first to add items to wishlist",
        });
        return;
    }

    // Check if size is required and not selected
    if (hasSizes && !selectedSize) {
      toast.error("Please select a size!");
      return;
    }

    dispatch(
      addProdToCart({
        productId: productState?._id,
        quantity,
        color,
        size: selectedSize,
        price: productState?.current_price,
      })
    );
    navigate("/cart");
  };

  const props = {
    width: 594,
    height: 600,
    zoomWidth: 600,
    zoomHeight: 600,
    img: imgUrl || "https://via.placeholder.com/594x600",
  };

  const [orderedProduct, setorderedProduct] = useState(true);
  const copyToClipboard = (text) => {
    var textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };

  const closeModal = () => {};
  const [popularProduct, setPopularProduct] = useState([]);
useEffect(() => {
  if (!productsState || productsState.length === 0) return;

  // Flatten all products from all categories
  const allProducts = productsState.flatMap(category => category.products);

  // Filter products that have sold > 0
  const soldProducts = allProducts.filter(product => product?.sold > 0);

  setPopularProduct(soldProducts);
}, [productsState]);

  const [star, setStar] = useState(null);
  const [comment, setComment] = useState(null);
  const [like, setLike] = useState(false);
  const [isFilled, setIsFilled] = useState(false);

  const handleToggle = () => {
      if (!getTokenFromLocalStorage) {
        setApiModal({
          show: true,
          type: "info",
          title: "Login Required",
          message: "Please login first to add items to wishlist",
        });
        return;
      }
    dispatch(addToWishlist(productState?._id));
    setIsFilled(!isFilled);
  };

  const addRatingToProduct = () => {
    if (!getTokenFromLocalStorage) {
    setApiModal({
          show: true,
          type: "info",
          title: "Login Required",
          message: "Please login first to add items to wishlist",
        });
        return;
    } else if (star === null) {
      toast.error("Please add star rating");
      return false;
    } else if (comment === null) {
      toast.error("Please Write Review About the Product");
      return false;
    } else {
      const formData = new FormData();
formData.append("star", star);
formData.append("comment", comment);
formData.append("prodId", getProductId);
ratingImages.forEach((file) => formData.append("images", file));

dispatch(addRating(formData));
      // dispatch(
      //   addRating({ star: star, comment: comment, prodId: getProductId })
      // );
      setTimeout(() => {
        dispatch(getAProduct(getProductId));
      }, 100);
    }
    return false;
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleBuyNow = () => {
    // if (!getTokenFromLocalStorage) {
    //   toast.error("Please login first!");
    //   return;
    // }

    // Check if size is required and not selected
    if (hasSizes && !selectedSize) {
      toast.error("Please select a size!");
      return;
    }

    navigate("/checkout", {
      state: {
        product: {...productState,
          color: color,
          size: selectedSize,
          quantity: quantity,
        },

      },
    });
  };


  // 🔹 SEO helpers (NON-BREAKING)
const stripHtml = (html) =>
  html ? html.replace(/<[^>]*>?/gm, "") : "";

const seoTitle = productState?.title
  ? `${productState.title} | Shoplintic`
  : "Product Details | Shoplintic";

const seoDescription = productState?.description
  ? stripHtml(productState.description).slice(0, 155)
  : "Buy quality fashion, clothing & lifestyle products online at Shoplintic.";

const canonicalUrl = productState?.slug
  ? `https://www.shoplintic.in/product/${productState.slug}`
  : window.location.href;
const generateImageAlt = (product, index = 0) => {
  if (!product) return "Shoplintic product image";

  const baseTitle = product.title
    ?.replace(/[^a-zA-Z0-9 ]/g, "")
    ?.trim();

  const category = product.category ? ` ${product.category}` : "";

  return `${baseTitle}${category} image ${index + 1} – Shoplintic`;
};
useEffect(() => {
  if (
    typeof navigator !== "undefined" &&
    /Googlebot|bingbot|yandex/i.test(navigator.userAgent)
  ) {
    document.documentElement.setAttribute("data-seo", "true");
  }
}, []);
const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 400,
  slidesToShow: 2,
  slidesToScroll: 1,
};

  return (
    <>
        <ApiResponseModal
  show={apiModal.show}
  type={apiModal.type}
  title={apiModal.title}
  message={apiModal.message}
  onClose={() =>
    setApiModal((prev) => ({ ...prev, show: false }))
  }
/>
    <Helmet>
  <title>{seoTitle}</title>
  <meta name="description" content={seoDescription} />
  <link rel="canonical" href={canonicalUrl} />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org/",
      "@type": "Product",
      name: productState?.title,
      image: productState?.images?.map((img) => img.url),
      description: stripHtml(productState?.description),
      brand: {
        "@type": "Brand",
        name: productState?.brand || "Shoplintic",
      },
      offers: {
        "@type": "Offer",
        url: canonicalUrl,
        priceCurrency: "INR",
        price: productState?.current_price,
        availability:
          productState?.quantity > 0
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
      },
      aggregateRating:
        productState?.ratings?.length > 0
          ? {
              "@type": "AggregateRating",
              ratingValue: productState?.totalrating,
              reviewCount: productState?.ratings?.length,
            }
          : undefined,
    })}
  </script>
</Helmet>

<Meta
  title={seoTitle}
  description={seoDescription}
  canonical={canonicalUrl}
/>

      <BreadCrumb title={productState?.title} />
      <h1 className="visually-hidden">{productState?.title}</h1>

      <Container class1="main-product-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="main-product-image d-none d-md-block">
              <ReactImageZoom {...props} />
            </div>
            <div className="main-product-image d-block d-md-none">
     <img
  src={imgUrl}
  className="img-fluid"
  alt={generateImageAlt(productState, 0)}
  onError={(e) => {
    e.currentTarget.onerror = null;
    const fallback = productState?.images?.[1]?.url ||
      "https://via.placeholder.com/600x600?text=No+Image";
    if (e.currentTarget.src !== fallback) {
      e.currentTarget.src = fallback;
    }
  }}
/>

            </div>
            <div className="other-product-images d-flex flex-wrap gap-15 mt-3">
              {productState?.images.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => setImgUrl(item.url)}
                    style={{ width: "100px" }}
                  >
                    <img
                      src={item?.url}
                      className="img-fluid"
                      alt=""
      onError={(e) => {
    e.target.onerror = null;
    e.target.src =productState.images[1].url;
  }}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="main-product-details">
              <div className="border-bottom">
                <h3 className="title">{productState?.title}</h3>
              </div>

              {/* <div className="d-flex flex-column flex-md-row gap-10 align-items-start align-items-md-center my-2">
            <h3 className="product-heading">Author :</h3>
            <p className="product-data">{productState?.author_name}</p>
          </div> */}

              <div className="border-bottom py-3">
                <del className="price">
                  {" "}
                  {symbole} {productState?.price}/-
                </del>
                <p className="price">
                  {" "}
                  {symbole} {productState?.current_price}/-
                </p>
                <p>
                  Save {symbole}{" "}
                  {parseInt(productState?.price) -
                    parseInt(productState?.current_price)}{" "}
                  (
                  {Math.round(
                    ((parseInt(productState?.price) -
                      parseInt(productState?.current_price)) /
                      parseInt(productState?.price)) *
                      100
                  )}
                  % off)
                </p>

                <div className="d-flex align-items-center gap-10">
                  <ReactStars
                    count={5}
                    size={24}
                    value={productState?.totalrating?.toString()}
                    edit={false}
                    activeColor="#ffd700"
                  />
                  <p className="mb-0 t-review">
                    ( {productState?.ratings?.length} Reviews )
                  </p>
                </div>
                <a className="review-btn" href="#review">
                  Write a Review
                </a>
              </div>

              <div className="py-3">
                <div className="d-flex  flex-md-row gap-10 align-items-start align-items-md-center my-2">
                  <h3 className="product-heading">Type :</h3>
                  <p className="product-data">{productState?.category}</p>
                </div>

                {/* Size Selection */}
                {hasSizes && (
                  <div className="d-flex  flex-md-row gap-10 align-items-start align-items-md-center my-2">
                    <h3 className="product-heading">SIZE :</h3>
                    <div className="d-flex gap-2">
                      {productState?.size?.map((s, index) => (
                        <button
                          key={index}
                          type="button"
                          className={`btn ${
                            selectedSize === s
                              ? "btn-primary"
                              : "btn-outline-secondary"
                          }`}
                          style={{
                            minWidth: "40px",
                            padding: "5px 10px",
                            fontSize: "14px",
                          }}
                          onClick={() => setSelectedSize(s)}
                        >
                          {s.toUpperCase()}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <div className="d-flex  flex-md-row gap-10 align-items-start align-items-md-center my-2">
                  <h3 className="product-heading">Category :</h3>
                  <p className="product-data">{productState?.category}</p>
                </div>

                <div className="d-flex  flex-md-row gap-10 align-items-start align-items-md-center my-2">
                  <h3 className="product-heading">Availability :</h3>
                  <p className="product-data">In Stock</p>
                </div>

                <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-15 mt-2 mb-3">
                  {alreadyAdded === false ? <h3 className="product-heading">Quantity :</h3> : <h3 className="product-heading text-danger">Already Added to Cart</h3>}
                  {alreadyAdded === false && (
                    <div>
                      <input
                        type="number"
                        min={1}
                        max={10}
                        className="form-control"
                        style={{ width: "70px" }}
                        onChange={(e) => setQuantity(e.target.value)}
                        value={quantity}
                      />
                    </div>
                  )}
                  <div
                    className={
                      alreadyAdded
                        ? "w-100 my-auto ms-0 d-flex flex-row align-items-center align-items-md-center gap-15"
                        : " w-100 ms-md-5 d-flex flex-row flex-md-row align-items-center align-items-md-center gap-1"
                    }
                  >
                    <button
                      className="button border-0 md-w-75 w-50"
                      type="button"
                      style={{ background: "#0053e2" }}
                      onClick={() => {
                        alreadyAdded ? navigate("/cart") : uploadCart();
                      }}
                      disabled={hasSizes && !selectedSize}
                    >
                      {alreadyAdded ? "Go to Cart" : "Add to Cart"}
                    </button>

                    {getTokenFromLocalStorage ? (
                      <button
                  className="button border-0 md-w-75 w-50"
                      type="button"
                      style={{ background: "#0053e2" }}
                        onClick={handleBuyNow}
                        disabled={hasSizes && !selectedSize}
                      >
                        <img
                          src={cart}
                          alt="addcart"
                          className="me-1"
                          style={{ width: "16px", height: "16px" }}
                        />{" "}
                        <span className="d-none d-sm-inline">Buy Now</span>
                        <span className="d-sm-none">Buy Now</span>
                      </button>
                    ) : (
                      <button
                  className="button border-0 md-w-75 w-50"
                      type="button"
                      style={{ background: "#0053e2" }}
                        onClick={handleBuyNow}
                        disabled={hasSizes && !selectedSize}
                      >
                        <img
                          src={cart}
                          alt="addcart"
                          className="me-1"
                          style={{ width: "16px", height: "16px" }}
                        />{" "}
                        <span className="d-none d-sm-inline">Buy Now</span>
                        <span className="d-sm-none">Buy Now</span>
                      </button>
                    )}
                  </div>
                </div>

                {hasSizes && !selectedSize && (
                  <div className="text-danger mt-2">
                    * Please select a size before adding to cart
                  </div>
                )}

                <div className="d-flex align-items-center gap-15">
                  <div>
                    {isFilled ? (
                      <AiFillHeart
                        className="fs-5 me-2"
                        onClick={handleToggle}
                      />
                    ) : (
                      <AiOutlineHeart
                        className="fs-5 me-2"
                        onClick={handleToggle}
                      />
                    )}
                  </div>
                </div>

                <div className="d-flex flex-column gap-10 my-3">
                  <h3 className="product-heading">Shipping & Returns :</h3>
                  <p className="product-data">
                    Free shipping and returns available on all orders! <br /> We
                    ship all India domestic orders within{" "}
                    <b>5-10 business days!</b>
                  </p>
                </div>

                <div className="d-flex flex-column flex-md-row gap-10 align-items-start align-items-md-center my-3">
                  <h3 className="product-heading">Product Link:</h3>
                  <a
                    href="javascript:void(0);"
                    onClick={() => {
                      copyToClipboard(window.location.href);
                    }}
                  >
                    {window.location.href.substring(0, 40)}...
                  </a>
                </div>

             <div className="description-wrapper d-flex flex-column gap-10 my-3">
  <h3 className="product-heading">About :</h3>

  <div className="product-data">
    <div
      dangerouslySetInnerHTML={{
        __html: showFullDesc
          ? productState?.description
          : productState?.description?.substring(0, DESCRIPTION_LIMIT) +
            (productState?.description?.length > DESCRIPTION_LIMIT
              ? "..."
              : ""),
      }}
    />

    {productState?.description?.length > DESCRIPTION_LIMIT && (
      <button
        className="btn btn-none btn-link text-decoration-none p-0 mt-2 view-more-btn"
        onClick={() => setShowFullDesc(!showFullDesc)}
      >
        {showFullDesc ? "View Less ▲" : "View More ▼"}
      </button>
    )}
  </div>
</div>

              </div>
            </div>
          </div>
        </div>
      </Container>

      <Container class1="description-wrapper py-5 home-wrapper-2 hide-on-mobile-view">
        <div className="row">
          <div className="col-12">
            <h4>Description</h4>
            <div className="bg-white p-3">
              <p
                dangerouslySetInnerHTML={{ __html: productState?.description }}
              ></p>
            </div>
        </div>
        </div>
      </Container>

      <Container class1="reviews-wrapper home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 id="review">Reviews</h3>
            <div className="review-inner-wrapper">
              <div className="review-head d-flex justify-content-between align-items-end flex-wrap">
                <div>
                  <h4 className="mb-2">Customer Reviews</h4>
                  <div className="d-flex align-items-center gap-10">
                    <ReactStars
                      count={5}
                      size={24}
                      value={productState?.totalrating?.toString()}
                      edit={false}
                      activeColor="#ffd700"
                    />
                    <p className="mb-0">
                      Based on {productState?.ratings?.length} Reviews
                    </p>
                  </div>
                </div>
                {orderedProduct && (
                  <div>
                    <a className="text-dark text-decoration-underline" href="">
                      Write a Review
                    </a>
                  </div>
                )}
              </div>

              <div className="review-form py-4">
                <h4>Write a Review</h4>
                <div>
                  <ReactStars
                    count={5}
                    size={24}
                    value={0}
                    edit={true}
                    activeColor="#ffd700"
                    onChange={(e) => {
                      setStar(e);
                    }}
                  />
                </div>
                <div>
                  <textarea
                    className="w-100 form-control"
                    cols="30"
                    rows="4"
                    placeholder="Comments"
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mt-2">
  <input
    type="file"
    multiple
    accept="image/*"
    onChange={(e) => setRatingImages([...e.target.files])}
  />
</div>

                <div className="d-flex justify-content-end mt-3">
                  <button
                    onClick={addRatingToProduct}
                    className="button border-0"
                    style={{ background: "#0053e2" }}
                    type="button"
                  >
                    Submit Review
                  </button>
                </div>
              </div>

              <div className="reviews mt-4">
                {productState &&
                  productState.ratings?.map((item, index) => {
                    return (
                      <div className="review" key={index}>
                        <h6 className="mb-0">
  {item?.postedby
    ? `${item?.postedby?.firstname || "User"} ${item?.postedby?.lastname || ""}`.trim()
    : "Guest User"}
</h6>

                          <ReactStars
                            count={5}
                            size={24}
                            value={item?.star}
                            edit={false}
                            activeColor="#ffd700"
                          />
{item?.images?.length > 0 && (
  <div
    className="mt-2"
    style={{
      display: "flex",
      width: "100%",
      overflow: "hidden",
    }}
  >
    <Slider
      {...sliderSettings}
      style={{
        width: "100%",
      }}
    >
      {item.images.map((img, i) => (
        <div
          key={i}
          style={{
            padding: "5px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={img.url}
            alt="review"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "6px",
              display: "block",
            }}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/100";
            }}
          />
        </div>
      ))}
    </Slider>
  </div>
)}


                        <p className="mt-3">{item?.comment}</p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </Container>

      <Container class1="popular-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">Our Popular Products</h3>
          </div>
        </div>
        <div className="row d-flex align-items-center mb-3">
          <ProductCard data={popularProduct} />
        </div>
      </Container>
    </>
  );
};

export default SingleProduct;